import React, { useEffect, useState } from "react";
import { Row, Col, Typography, Table, Spin, Collapse, Card, Tag, message } from "antd";
import { BASE_URL } from "../Components/Constant";
import ApiService from "./apiService";
import { Link } from "react-router-dom";

const { Title } = Typography;
const { Panel } = Collapse;

const PackageBatch = ({ recordData }) => {
    const [packages, setPackages] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchPackageData();
    }, []);

    const fetchPackageData = async () => {
        try {
            setLoading(true);
            const packageService = new ApiService(`${BASE_URL}/fetch_records_parent_childs/PacakgedOutput/Batch_id/${recordData?._id}`, {}, "GET");
            const packageRes = await packageService.makeCall();
            setPackages(packageRes);


        } catch (err) {
            const errorMessage = err && typeof err === 'object'
                ? Object.entries(err).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
                : 'Failed to fetch due to unknown error';
            message.error(errorMessage);
        } finally {
            setLoading(false);
        }
    };



    return (
        <Spin spinning={loading} size="medium">
            <div style={{ width: "100%" }}>
                <Row justify="space-between" align="middle" style={{ marginBottom: 10 }}>
                    <Col>
                        <Title level={3} style={{ marginTop: "10px" }}>Packaged Batch Details</Title>
                    </Col>
                </Row>

                <Collapse>
                    {packages.map(packaging => (
                        <Panel
                            header={
                                <div style={{ display: "flex", alignItems: "center", gap: "10px", }}>
                                    {packaging.Name}
                                </div>
                            }
                            key={packaging._id}>
                            <Card title="Processing Details" style={{ marginBottom: 10 }}>
                                <Row gutter={16}>
                                    <Col span={6} style={{ borderRight: "1px solid #d9d9d9", padding: "10px" }}>
                                        <Typography.Text style={{ fontSize: '18px' }} strong> Name</Typography.Text>
                                        <div style={{ fontSize: '15px' }}>
                                            {packaging?.Name ? (
                                                <Link to={`/record/PacakgedOutput/${packaging._id}`}>{packaging.Name}</Link>
                                            ) : (
                                                ""
                                            )}
                                        </div>
                                    </Col>
                                    <Col span={6} style={{ borderRight: "1px solid #d9d9d9", padding: "10px" }}>
                                        <Typography.Text style={{ fontSize: '18px' }} strong>Batch Name</Typography.Text>
                                        <div style={{ fontSize: '15px' }}>
                                            {packaging?.Batch?.Name ? (
                                                <Link to={`/record/PacakgedOutput/${packaging?.Batch._id}`}>{packaging.Batch?.Name}</Link>
                                            ) : (
                                                ""
                                            )}
                                        </div>
                                    </Col>
                                    <Col span={6} style={{ borderRight: "1px solid #d9d9d9", padding: "10px" }}>
                                        <Typography.Text style={{ fontSize: '18px' }} strong>Packaging Product</Typography.Text>
                                        <div style={{ fontSize: '15px' }}>{packaging.Product?.Name}</div>
                                    </Col>

                                    <Col span={6} style={{ borderRight: "1px solid #d9d9d9", padding: "10px" }}>
                                        <Typography.Text style={{ fontSize: '18px' }} strong>Quantity</Typography.Text>
                                        <div style={{ fontSize: '15px' }}>{packaging.Quantity ? packaging.Quantity : "0.00"} Bags/Buckets</div>
                                    </Col>

                                    <Col span={6} style={{ borderRight: "1px solid #d9d9d9", padding: "10px" }}>
                                        <Typography.Text style={{ fontSize: '18px' }} strong>Weight</Typography.Text>
                                        <div style={{ fontSize: '15px' }}>{packaging?.Weight ? packaging?.Weight : "0.00"} Metric Tons</div>
                                    </Col>
                                </Row>
                            </Card>

                        </Panel>
                    ))}
                </Collapse>
            </div>
        </Spin>
    );
};

export default PackageBatch;
